import OLXYZ from 'ol/source/XYZ'
import OLOSM from 'ol/source/OSM'
import OLVectorSource from 'ol/source/Vector.js'
import OLImageWMS from 'ol/source/ImageWMS'
import OLTileWMS from 'ol/source/TileWMS'
import OLTileImage from 'ol/source/TileImage'
import {Feature} from './Feature'
import {Point, Polygon, LineString} from './Geometry'
import {GeometryType} from '../../enums/GeometryType'
import {Projection} from '..'
import * as events from 'ol/events'
import type {default as OlGeometry} from 'ol/geom/Geometry'

class XYZ extends OLXYZ {
  _opt_options: any
  constructor(opt_options?: any) {
    super(opt_options)
    this._opt_options = opt_options
  }
  cloneInitSource(): XYZ {
    return new XYZ({...this._opt_options, params: {...this._opt_options.params}})
  }
}

class OSM extends OLOSM {
  _opt_options: any
  constructor(opt_options?: any) {
    super(opt_options)
    this._opt_options = opt_options
  }
  cloneInitSource(): OSM {
    return new OSM({...this._opt_options, params: {...this._opt_options.params}})
  }
}

class VectorSource extends OLVectorSource<any> {
  _opt_options: any
  constructor(opt_options?: any) {
    super(opt_options)
    this._opt_options = opt_options
  }
  cloneInitSource(): VectorSource {
    return new VectorSource({...this._opt_options, params: {...this._opt_options.params}})
  }
  addFeature(feature: any) {
    super.addFeature(feature as any)
  }
  addFeatures(features: any) {
    super.addFeatures(features as any)
  }
  getFeatureById(id: string | number): any {
    return super.getFeatureById(id) as any
  }
  eventCache: {[key: string]: (e: any) => void} = {}
  addEvent(key: string, func: (e: any) => void) {
    this.eventCache[key] = func
    this.on(key as any, this.eventCache[key])
  }
  disableEvents() {
    for (const key in this.eventCache) {
      this.un(key as any, this.eventCache[key])
    }
  }
  enableEvents() {
    for (const key in this.eventCache) {
      this.on(key as any, this.eventCache[key])
    }
  }
}

class ImageWMS extends OLImageWMS {
  _opt_options: any
  constructor(opt_options?: any) {
    super(opt_options)
    this._opt_options = opt_options
  }
  cloneInitSource(): ImageWMS {
    return new ImageWMS({...this._opt_options, params: {...this._opt_options.params}})
  }
}

class TileWMS extends OLTileWMS {
  _opt_options: any
  constructor(opt_options?: any) {
    super(opt_options)
    this._opt_options = opt_options
  }
  cloneInitSource(): TileWMS {
    return new TileWMS({...this._opt_options, params: {...this._opt_options.params}})
  }
}

class TileImage extends OLTileImage {
  _opt_options: any
  constructor(opt_options?: any) {
    super(opt_options)
    this._opt_options = opt_options
  }
  cloneInitSource(): TileImage {
    return new TileImage({...this._opt_options, params: {...this._opt_options.params}})
  }
}

type Source = XYZ | OSM | ImageWMS | TileWMS | TileImage
export {XYZ, OSM, VectorSource, ImageWMS, TileWMS, TileImage, Source}
